export default __webpack_public_path__ + "static/media/Factory_Services-PreStaging.bc514c9d.mp4";